/** A document's review pane handed to the item page's side panel (notesSlot.ts). */

import { useEffect } from "preact/hooks";
import type { NotesPane } from "../../office/review/notes.ts";
import { notesSlot } from "./notesSlot.ts";

/** Hands `pane` (item `item`'s) to the side panel while it's shown. */
export function PublishNotes({ item, pane }: { item: string; pane: NotesPane }) {
  useEffect(() => {
    notesSlot.value = { item, pane };
  });
  useEffect(
    () => () => {
      if (notesSlot.value?.item === item) {
        notesSlot.value = null;
      }
    },
    [item],
  );
  return null;
}
